import { render, staticRenderFns } from "./user-details.vue?vue&type=template&id=1c18ad0e&scoped=true&"
import script from "./user-details.ts?vue&type=script&lang=ts&"
export * from "./user-details.ts?vue&type=script&lang=ts&"
import style0 from "./user-details.scss?vue&type=style&index=0&id=1c18ad0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c18ad0e",
  null
  
)

export default component.exports